import * as styles from './FileInput.module.css'

import React from 'react'

interface Props extends Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  'className' | 'type'
> {}

export const FileInput: React.FC<Props> = (props) => {
  const { ...inputProps } = props

  return <input type="file" className={styles.input} {...inputProps} />
}
